<template>
  <div class="address" :style="{marginBottom: mb}">
    <img src="@/assets/images/icons/map-pin.svg" alt="">
    <span><slot></slot></span>
  </div>
</template>

<script>
  export default {
    name: 'address-component',
    props: {
      mb: String
    }
  }
</script>

<style scoped lang="scss">
  .address {
    margin-left: -3px;
    display: flex;
    align-items: center;
    img {
      margin-right: 6px;
    }
    span {
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      line-height: 1.4;
      color: #383838;
    }
  }

</style>
